import * as React from "react";
import {AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer} from "recharts";
import styles from "./chart.module.scss";
import SelectBox from "../../../../Componnets/SelectBox/SelectBox";
import {useEffect} from "react";

const Chart = ({ data, dataPoolName }) => {
  const [selectedValue, setSelectedValue] = React.useState()
  const [chartData, setChartData] = React.useState([])

  const handleSelectYear = (year) => {
    setSelectedValue(year)
    const selectedYearData = data[year.value]
    setChartData(Object.entries(selectedYearData).map(([key, value]) => ({
      name: key,
      value
    })))
  }

  useEffect(() => {
    if (data) {
      handleSelectYear(Object.keys(data)?.map(item => ({title: item, value: item}))?.[0])
    } else {
      setChartData([])
    }
  }, [data])

  return (
    <div className={'col-md-6'}>
      <div className={styles.chart}>
        <div className={'d-flex justify-content-between'} style={{marginBottom: 38}}>
          <div className={'d-flex'}>
            <div className={styles.title}>
              Case Frequency
            </div>
            <div className={styles.desc}>
              { dataPoolName }
            </div>
          </div>
          <div className={styles.selectBox}>
            {
              data &&
                <SelectBox
                  style={{border: 0, fontSize: 14, fontWeight: 700, color: "#0A195C"}}
                  singleSelect
                  block
                  options={Object.keys(data)?.map(item => ({title: item, value: item}))}
                  dropDownValue={selectedValue}
                  onSelectOption={handleSelectYear}
                  dontShowSearch
                />
            }
          </div>
        </div>
        <ResponsiveContainer height={200}>
          <AreaChart data={chartData}
                     margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="35%" stopColor="#C485FF" stopOpacity={0.8}/>
                <stop offset="90%" stopColor="#D9D9D9" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <XAxis dataKey="name" fontWeight={500} color={"#70789E"} fontSize={14} />
            <YAxis fontWeight={500} color={"#70789E"} fontSize={14} />
            <CartesianGrid opacity={0.3} strokeDasharray="3 0" vertical={false} />
            <Tooltip />
            <Area strokeWidth={2} type="monotone" dataKey="value" stroke="#8A0FFF" fillOpacity={1} fill="url(#colorUv)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}

export default Chart